import { FormControlLabel, FormGroup, Switch, SwitchProps } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../contexts/app_context/app_context";

/**
 * SwitchPrimary
 */

interface Props extends SwitchProps {
  label: string
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom',
}

function SwitchPrimary({ label, labelPlacement, ...props }: Props) {
  const { theme } = useContext(AppContext)
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            sx={{
              color: "#009C4E",
              '& .MuiSwitch-switchBase': {
                '&.Mui-checked': {
                  color: '#009C4E',
                  '& + .MuiSwitch-track': {
                    backgroundColor: '#009C4E',
                  },
                },
              }
            }}
            {...props}
          />}
        sx={{ color: theme === "dark" ? "white" : "black" }}
        label={label}
        labelPlacement={labelPlacement} />
    </FormGroup>
  );
}

export default SwitchPrimary;